import { UtilsTypes } from '@tencent/wphk-act-base-types';

/**
 * 展示券信息
 */
export type CouponInfo = {
  /** 商户ID */
  spId: string,
  /** 券ID */
  couponId: string,
  /** 用户券id，当券领取后可以展示，需注意未来变成多张券的情况，可能需要处理 */
  userScid: string,
  /** 展示券图片URL */
  goodsUrl: string,
  /** 展示券名称 */
  couponName: string,
  /** 券的价值 */
  couponValue: string,
  /** 使用条件(展示券才有) */
  couponCondition: string,
  /** 券的上架时间在一周内（T - 7） */
  isNew: Boolean,
  /** 券可领开始时间 */
  startTime?: string,
  /** 券可领结束时间 */
  endTime?: string,
  /** 生效时间 */
  validTime?: string,
  /** 生效时间类型 */
  validType?: DateType,
  /** 相对生效天数 */
  validDay?: number,
  /** 过期时间 */
  expireTime?: string,
  /** 过期时间类型 */
  expireType?: DateType,
  /** 过期相对天数 */
  expireDay?: number,
  /** 所属商户信息 */
  merchantInfo: MerchantInfo,
  /** 券状态 */
  state: CouponState,

  /** 券类型 */
  type: CardType,
  /** 核销金额(优惠券才有) */
  requireNum: string;
  /** 适用商户 */
  couponRange: string;
  /** 币种类型 */
  currencyType?: UtilsTypes.CurrencyType;
};

/** 卡片类型 */
export enum CardType {
  /** 展示券（店面出示条形码） */
  DisplayCoupon = 0,
  /** 自定义广告（分享券（分裂券）） */
  Ad = 1, // 留意：这个值会跟dp拉回来的数据属性cardType比较，不能随便改
  /** 优惠券（折扣/立减，WeChatPay HK支付自动扣减） */
  AutoCoupon = 2,
}


/**
 * 时间类型
 */
export enum DateType {
  /** 绝对时间 */
  absolute = 1,
  /** 相对时间 */
  relative = 2
}

/**
 * 商户展示券状态枚举
 */
export enum CouponState {
  /** 可领取 */
  Normal = 1,
  /** 已领取 */
  Got,
  /** 已领完 */
  Empty,
  /** 已使用 */
  Used,
  /** 已过期 */
  Expired,
  /** 未解锁 */
  Locked,
};

/**
 * 商户信息
 */
export type MerchantInfo = {
  /**
   * 商户ID
   */
  spId: string,
  /**
   * logo地址
   */
  spLogo: string,
  /**
   * 商户名
   */
  spName: string,
  /**
   * 商户展示券累计折扣总值
   */
  totalValue: number,
  /**
   * 商户名下是有可领展示券
   */
  state: MerchantState,
  /**
   * 币种类型
   */
  currencyType?: UtilsTypes.CurrencyType,
  /**
   * 多币种时的券数量
   */
  totalCnt?: number,
};

/**
 *  商户状态
 */
export enum MerchantState {
  /** 可领取（存在该用户未领取，且未派完的券） */
  Normal = 1,
  /** 已领取（该商户下的券，用户全部已领取） */
  Got = 2,
  /** 已领完（该商户下的券，用户都没有领，且全都已派完了；或者用户没有领的那些券，都已经派完了） */
  Empty = 3,
  /** 没有领取区间内的券 */
  None = 4
};

/**
 * 券入口的上报信息
 */
export type CouponEntryReportInfo = {
  /** 所在入口，首页列表、搜索列表 */
  entry?: string;
  /** 所在列的位置，第几列 */
  col?: string;
  /** 所在列的索引， 第几个 */
  row?: string;
};
